"use client";

import Link from "next/link";
import { Box, Stack, Typography } from "@mui/material";

type BrandLogoProps = {
  href: string;
};

export function BrandLogo({ href }: BrandLogoProps) {
  return (
    <Link href={href} style={{ textDecoration: "none", color: "inherit" }}>
      <Stack direction="row" spacing={1.25} alignItems="center">
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: 1.5,
            border: "1px solid hsl(var(--border))",
            background: "hsl(var(--card))",
            boxShadow: "0 4px 14px hsl(var(--foreground) / 0.08)",
            overflow: "hidden",
            display: "grid",
            placeItems: "center",
          }}
        >
          <Box
            component="img"
            src="/logo192_transpbg.png"
            alt="Logo Análise de FIIs"
            sx={{
              width: 36,
              height: 36,
              objectFit: "contain",
              transform: "scale(1.28)",
            }}
          />
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: 11,
              letterSpacing: 1.2,
              textTransform: "uppercase",
              color: "inherit",
              opacity: 0.84,
              lineHeight: 1.1,
              fontWeight: 700,
            }}
          >
            Análise de
          </Typography>
          <Typography
            sx={{
              fontFamily: "var(--font-display)",
              fontSize: 22,
              lineHeight: 1,
              fontWeight: 700,
              letterSpacing: 0.2,
              color: "inherit",
            }}
          >
            FIIs
          </Typography>
        </Box>
      </Stack>
    </Link>
  );
}
